import { useCallback } from 'react';

import {
  FamilyTreeActionFn,
  FamilyTreeDataLoadedAction,
  FamilyTreeNodeConfig,
  FamilyTreeNodePosition,
} from '../types';

export function useFamilyTreeDataLoadedAction() {
  return useCallback<FamilyTreeActionFn<FamilyTreeDataLoadedAction>>(
    (state, action, queueEffect) => {
      queueEffect({ type: 'marriageLayoutEffect' });

      // Load visualization config from the fetched settings
      const visualizationConfig = action.familyTreeData?.settings
        ? {
            showAge: action.familyTreeData.settings.showAge,
            showHiddenIndividuals:
              action.familyTreeData.settings.showHiddenIndividuals,
            showNotes: action.familyTreeData.settings.showNotes,
            showStateOfResidence:
              action.familyTreeData.settings.showStateOfResidence,
          }
        : state.visualizationConfig;

      // Load node configs from the fetched people
      const nodeConfigs: Record<string, FamilyTreeNodeConfig> = {};
      action.familyTreeData?.people?.forEach((person) => {
        nodeConfigs[person.clientProfile.id] = {
          showTile: person.nodeSettings.showIndividualOnTree,
          showNotes: person.nodeSettings.showNotesForIndividual,
        };
      });

      // Load saved node positions from the family tree settings
      const nodePositions: FamilyTreeNodePosition[] =
        action.familyTreeData?.settings?.nodeConfigurations?.map((config) => ({
          nodeID: config.nodeID,
          xPosition: config.xPosition ?? 0,
          yPosition: config.yPosition ?? 0,
        })) ?? [];

      return {
        ...state,
        familyTreeData: action.familyTreeData,
        clientProfiles: action.clientProfiles,
        isInitializingFlowchart: true,
        visualizationConfig,
        nodeConfigs,
        // Settings refetches must not replace the layout being edited.
        nodePositions: state.hasUnsavedNodePositions
          ? state.nodePositions
          : nodePositions,
      };
    },
    []
  );
}
